import React from 'react';

import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { FloatingLabelSelect } from 'components/floating-label-fields';
import { ISOs } from 'utils/form/constants';

import { IProps } from './types';

const CountryDisclaimer = styled.p`
  color: ${Styles.color.grey.two};
  font-family: ${Styles.fontFamily.body};
  font-size: 0.75rem;
  margin-top: -0.25rem;
`;

/** @deprecated Use CountrySelect instead */
const CountrySelectInput = ({
  'data-testid': testId,
  value,
  onChange,
  label,
  disabled,
  name,
  message,
  validation,
  disclaimer,
}: IProps<HTMLSelectElement>) => {
  const { formatMessage } = useIntl();

  let options: { label: string; value: string }[] = [
    { label: formatMessage({ id: 'unitedStates' }), value: ISOs.USA },
    { label: formatMessage({ id: 'canada' }), value: ISOs.CAN },
  ];

  if (value === '') {
    options = [{ value: '', label: formatMessage({ id: 'selectACountry' }) }, ...options];
  }

  return (
    <>
      <FloatingLabelSelect
        required
        label={label}
        name={name}
        value={value}
        options={options}
        onChange={onChange}
        disabled={disabled}
        message={message}
        validation={validation}
        data-testid={testId}
      />
      {disclaimer && (
        <CountryDisclaimer data-testid="country-input-disclaimer">{disclaimer}</CountryDisclaimer>
      )}
    </>
  );
};

export default CountrySelectInput;
